// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { TvInstrumentQuoteManager } from './TvInstrumentQuoteManager';
import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
export class TvQuoteRealtimeManager {
    constructor(host) {
        this.subscribedSymbolsMap = new Map();
        this.host = host;
    }
    subscribeRealtime(symbol) {
        const instrument = this.getInstrument(symbol);
        if (isNullOrUndefined(instrument) || this.subscribedSymbolsMap.has(symbol)) {
            return;
        }
        const newInsQuoteManager = new TvInstrumentQuoteManager(instrument, this.host);
        this.subscribedSymbolsMap.set(symbol, newInsQuoteManager);
    }
    unsubscribeRealtime(symbol) {
        const newInsQuoteManager = this.subscribedSymbolsMap.get(symbol);
        if (isNullOrUndefined(newInsQuoteManager)) {
            return;
        }
        newInsQuoteManager.unsubscribeRealtime();
        this.subscribedSymbolsMap.delete(symbol);
    }
    changeCurrentAccount() {
        this.subscribedSymbolsMap.forEach((manager, symbol) => {
            const instrument = this.getInstrument(symbol);
            if (isNullOrUndefined(instrument)) {
                console.warn(`TvQuoteRealtimeManager::changeCurrentAccount::Instrument ${symbol} not found`);
                return;
            }
            manager.throttledSendRealtimeUpdate();
        });
    }
    getInstrument(symbol) {
        const interiorId = TvInteriorIdCache.getInteriorId(symbol);
        const instrument = DataCache.getInstrumentByName(interiorId);
        return instrument;
    }
}
